<template>
    <v-dialog :value="showsSeek" persistent width="480">
        <v-card class="fill-height ma-0 black" dark tile loading>
            <v-card-title> 참여 대기 중 </v-card-title>
            <v-card-text>
                참여요청이 발송되었습니다. <br />
                관리자 승인 시 참여가 가능합니다.
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
export default {
    computed: {
        ...mapGetters("interview", ["showsSeek"]),
    },
};
</script>

<style>
</style>